import { ListItemIconProps, ListItemIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ListItemIconStyled = styled(ListItemIcon)<ListItemIconProps>(() => ({
  '&.MuiListItemIcon-root': {
    minWidth: '25px',
  },
}));
